<div class="aria-description">
    <ng-content></ng-content>
</div>
